module.exports = __webpack_public_path__ + "static/media/electricity.0fd48486.svg";